import { NumericTextBox } from "@tql/ui-components-react/tql/inputs/beta";

/**
 * Freight totals summary. `overwriteLinearFeet` is only editable in edit mode,
 * where `calculatedLinearFeet` shows the raw calculated value so the difference
 * between the two is visible.
 */
export const FreightTotalsCard = ({
	handlingUnits,
	totalWeight,
	calculatedLinearFeet,
	overwriteLinearFeet,
	isEditing,
	onOverwriteChange,
}: {
	handlingUnits: number;
	totalWeight: number;
	calculatedLinearFeet: number;
	overwriteLinearFeet: number | null;
	isEditing: boolean;
	onOverwriteChange: (value: number | null) => void;
}) => (
	<div className={"freight-totals"} data-testid={"freight-totals"}>
		<h3 className={"freight-totals-title"}>Totals</h3>
		<div className={"freight-totals-details"}>
			<div className={"freight-totals-item"}>
				<div className={"section-label"}>Handling Units</div>
				<div data-testid={"freight-total-handling-units"}>
					{handlingUnits.toLocaleString("en-US")}
				</div>
			</div>
			<div className={"freight-totals-item"}>
				<div className={"section-label"}>Total Weight</div>
				<div data-testid={"freight-total-weight-summary"}>
					{totalWeight.toLocaleString("en-US")}
				</div>
			</div>
			<div className={"freight-totals-item"}>
				<div className={"section-label"}>Calculated Linear Feet</div>
				<div data-testid={"freight-calculated-linear-feet"}>
					{calculatedLinearFeet > 0
						? calculatedLinearFeet.toLocaleString("en-US")
						: "N/A"}
				</div>
			</div>
			{isEditing ? (
				<div
					className={"freight-totals-item"}
					data-testid={"freight-overwrite-linear-feet"}
				>
					<div className={"section-label"}>
						Overwrite Calculated Linear Feet
					</div>
					<NumericTextBox
						aria-label={"Overwrite Calculated Linear Feet"}
						min={0}
						onChange={(event) => {
							// The clear ("x") button reports 0 instead of null, and 0 or
							// negative are never valid overwrites, so treat all as "cleared".
							if (event.value !== null && event.value <= 0) {
								onOverwriteChange(null);
								return;
							}
							onOverwriteChange(event.value);
						}}
						valid={overwriteLinearFeet === null || overwriteLinearFeet > 0}
						value={overwriteLinearFeet}
					/>
				</div>
			) : null}
		</div>
	</div>
);
